export function roundStringNumber(
    num: string | undefined,
    scale: number,
    keepsDecimal0: boolean = false,
): string | undefined {
    if (!num) {
        return num;
    }
    const numFloat = Number.parseFloat(num);

    let result = numFloat.toFixed(scale);
    if (!keepsDecimal0) {
        //supprime les 0 après la virgule
        result = Number.parseFloat(result).toString();
    }
    return result.replace('.', ',');
}

export function stringToNumber(num: string): number {
    return Number.parseFloat(num.replace(',', '.'));
}

export function numberToString(num: number): string {
    return num.toString().replace('.', ',');
}
